module.exports = __webpack_public_path__ + "static/media/playstore-4d.30018cd3.png";